import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=28b85e63&"
import script from "./MeetingDetails.vue?vue&type=script&lang=js&"
export * from "./MeetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./MeetingDetails.vue?vue&type=style&index=0&id=28b85e63&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports